import { render, staticRenderFns } from "./Rol.vue?vue&type=template&id=19125aca&scoped=true"
import script from "./Rol.vue?vue&type=script&lang=js"
export * from "./Rol.vue?vue&type=script&lang=js"
import style0 from "./Rol.vue?vue&type=style&index=0&id=19125aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19125aca",
  null
  
)

export default component.exports